@if(this.router.url == '/language'){
<div class=" page pageLanguage">
  <router-outlet />
</div>
} @else {
<div class="page">
  @if(this.router.url !== '/' && this.router.url !== '/language'){
  <app-header />
  <div class="controller">
    <app-back-button />
    <app-language-dropdown />
  </div>

  } @if(this.router.url !== '/orders'){

  <app-order-list-button />
  }
  <router-outlet />
</div>
}
